import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBulb = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M11.25 18.25h-2.5m6.5-10.757V7a5.25 5.25 0 1 0-10.5 0v.493c0 1.722.86 3.33 2.294 4.286.441.294.706.79.706 1.32v1.583c0 .314.254.568.568.568h3.364a.568.568 0 0 0 .568-.568v-1.584c0-.53.265-1.025.706-1.319a5.152 5.152 0 0 0 2.294-4.286Z"
	})]
});
const ForwardRef = forwardRef(SvgBulb);
export { ForwardRef as ReactComponent };
